import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useAuth } from "../../auth/AuthContext";

export default function ResellerClients(){

  const { user } = useAuth();
  const [clients, setClients] = useState([]);

  useEffect(()=>{

    const load = async ()=> {
      const ref = collection(db, "resellers", user.resellerId, "clients");
      const snap = await getDocs(ref);

      const list = [];
      snap.forEach(docSnap => list.push(docSnap.data()));
      setClients(list);
    };

    load();

  }, []);

  return(
    <div className="min-h-screen bg-gray-950 text-white px-6 py-10">

      <h1 className="text-3xl font-bold mb-8">Your Clients</h1>

      <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

        {clients.length === 0 && (
          <p className="text-gray-400">No clients found.</p>
        )}

        {clients.map(c => (
          <div key={c.businessId} className="py-4 border-b border-gray-800">
            <p className="font-semibold">{c.businessName}</p>
            <p className="text-gray-500">{c.businessId}</p>
          </div>
        ))}

      </div>

    </div>
  );
}
